import { createFileRoute } from '@tanstack/react-router'
import { PhoneNumberProvidersPage } from '@/features/operations/phone-number-providers'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/did-providers/')({
  component: PhoneNumberProvidersPage,
  beforeLoad: requireRole(['admin']),
})
